import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({ className }: Props) => (
  <svg className={className} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
  <path d="M3.03333 21.6125L0 18.5792L7.8 10.7792L0 3.03333L3.03333 0L10.8333 7.8L18.5792 0L21.6125 3.03333L13.8125 10.7792L21.6125 18.5792L18.5792 21.6125L10.8333 13.8125L3.03333 21.6125Z" fill="white"/>
</svg>
);

export default Icon;
